export default __webpack_public_path__ + "static/media/Rectangle 790.d1c5ff74.png";